import React from "react";
import "./accordion.scss";
export default class Accordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      height: 0,
    };

    this.toggleCardState = this.toggleCardState.bind(this);
  }

  toggleCardState(e) {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    const { title, children } = this.props;
    const { expanded } = this.state;

    return (
      <div className="column">
        <div className={"card " + (expanded ? "expanded" : "not-expanded")}>
          <header className="card-header" onClick={this.toggleCardState}>
            <p className="card-header-title">{title}</p>
            <span className="card-header-icon">
              <span className="icon">
                <i className="fa fa-angle-up"></i>
              </span>
            </span>
          </header>
          <div
            className="card-content"
            style={{ maxHeight: expanded ? "" : "0" }}
            ref={(content) => (this.content = content)}
          >
            <div className="content">{children}</div>
          </div>
        </div>
      </div>
    );
  }
}
